import { render, staticRenderFns } from "./addHklrCancellationInsurance.vue?vue&type=template&id=0ed851e0"
import script from "./addHklrCancellationInsurance.vue?vue&type=script&lang=js"
export * from "./addHklrCancellationInsurance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports